import * as Yup from "yup";

export const getNotificacionNuevoValidationSchema = (allArtValue) =>
    Yup.object({
        selectedArt: Yup.mixed().required("Campo obligatorio"),
        selectedProviders: Yup.array()
            .of(Yup.mixed())
            .when("selectedArt", {
                is: (selectedArt) => selectedArt !== allArtValue,
                then: (schema) => schema.min(1, "Debe seleccionar al menos un prestador"),
                otherwise: (schema) => schema,
            }),
        selectedCategory: Yup.string().required("Campo obligatorio"),
        selectedMessage: Yup.mixed().required("Campo obligatorio"),
        description: Yup.string().trim().required("Campo obligatorio"),
    });
